var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      attrs: {
        align: "stretch"
      }
    },
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [_c("change-password")],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [_c("two-factor-auth")],
        1
      ),
      _vm.is2FAEnabled
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [_c("change-security-questions")],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }